module.exports = new __parcel__URL__("tree.e431cf61.webp").toString();